import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class DistributeType extends AStringEnum
{
	public constructor(value:AString)
	{
		super(value, DistributeType._types);
	}

	public toString():string
	{
		return this.value ? this.value.toString() : null;
	}

	public static START = new AString('Start');
	public static END = new AString('End');
	public static CENTER = new AString('Center');
	public static SPACE_BETWEEN = new AString('Space Between');
	public static SPACE_AROUND = new AString('Space Around');
	public static SPACE_EVENLY = new AString('Space Evenly');

	private static _types:Array<AString> = [
		DistributeType.START,
		DistributeType.END,
		DistributeType.CENTER,
		DistributeType.SPACE_BETWEEN,
		DistributeType.SPACE_AROUND,
		DistributeType.SPACE_EVENLY
	];

	public static start():DistributeType
	{
		return new DistributeType(DistributeType.START);
	}

	public static end():DistributeType
	{
		return new DistributeType(DistributeType.END);
	}

	public static center():DistributeType
	{
		return new DistributeType(DistributeType.CENTER);
	}

	public static spaceBetween():DistributeType
	{
		return new DistributeType(DistributeType.SPACE_BETWEEN);
	}

	public static spaceAround():DistributeType
	{
		return new DistributeType(DistributeType.SPACE_AROUND);
	}

	public static spaceEvenly():DistributeType
	{
		return new DistributeType(DistributeType.SPACE_EVENLY);
	}

	public static isStart(type:DistributeType):boolean
	{
		return DistributeType.start().isEqualTo(type);
	}

	public static isEnd(type:DistributeType):boolean
	{
		return DistributeType.end().isEqualTo(type);
	}

	public static isCenter(type:DistributeType):boolean
	{
		return DistributeType.center().isEqualTo(type);
	}

	public static isSpaceBetween(type:DistributeType):boolean
	{
		return DistributeType.spaceBetween().isEqualTo(type);
	}

	public static isSpaceAround(type:DistributeType):boolean
	{
		return DistributeType.spaceAround().isEqualTo(type);
	}

	public static isSpaceEvenly(type:DistributeType):boolean
	{
		return DistributeType.spaceEvenly().isEqualTo(type);
	}

	public static fromString(value:string):DistributeType
	{
		return new DistributeType(AString.fromString(value));
	}
}
